import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";

export const getShopProducts = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/products`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}